/* eslint-disable import/no-cycle */
import Request from '../utils/request.js';
import Native from '../utils/nativeProxy';

export default class VipService {
  static getVipInfo() {
    return Native.getCityInfo().catch(() => ({})).then((data) => (Request.post({
      action: 'user.vip.info',
      cityCode: data.citycode,
      adCode: data.adcode,
    }, null, true).then((response) => response.data)));
  }

  static chargeVipWechat({
    packageId, amount, adCode, cityCode, openId,
  }) {
    return Request.post({
      action: 'user.deposit.h5WechatPreOrder',
      packageId,
      amount,
      cityCode,
      adCode,
      openId,
      type: 10,
    }, null, true).then((res) => res.data);
  }

  static chargeVipAlipay({
    packageId, amount, cityCode, adCode,
  }) {
    return Request.post({
      action: 'user.deposit.wapAliPayPreOrder',
      packageId,
      amount,
      cityCode,
      adCode,
      type: 10,
    }, null, true).then((res) => res.data);
  }
}
